import type { LocationQueryValue } from 'vue-router'

/** Chaves de status aceitas no `?status=` da fila (as mesmas do dropdown). */
export const STATUS_KEYS = ['in_progress', 'approved', 'rejected', 'reverted', 'cancelled']

/** Seleção quando a URL não traz `status` (primeira entrada e "Limpar todos os filtros"). */
export const DEFAULT_STATUS_KEYS: readonly string[] = ['in_progress']

/** Liga/desliga um status sem mexer nos demais já selecionados. */
export function toggleStatusKey(keys: readonly string[], key: string): string[] {
  return keys.includes(key) ? keys.filter((k) => k !== key) : [...keys, key]
}

/**
 * Lê a seleção do `?status=`. Parâmetro ausente → padrão (`in_progress`);
 * `?status=` vazio → seleção vazia explícita (lista sem filtro de status),
 * para a escolha do usuário sobreviver a F5 e a link compartilhado. Valor só com
 * chaves desconhecidas (link adulterado) cai no padrão, não em "sem filtro".
 */
export function parseStatusKeysFromQuery(
  raw: LocationQueryValue | LocationQueryValue[] | undefined
): string[] {
  if (raw === undefined) return [...DEFAULT_STATUS_KEYS]
  const value = Array.isArray(raw) ? raw[0] : raw
  if (!value) return []
  const keys = value.split(',').filter((key) => STATUS_KEYS.includes(key))
  return keys.length ? keys : [...DEFAULT_STATUS_KEYS]
}

/** Seleção vazia vira `''`, que o router grava como `?status=`. */
export function serializeStatusKeys(keys: readonly string[]): string {
  return keys.join(',')
}
